module.exports = __webpack_public_path__ + "static/media/job_modal_bottom.1110f404.svg";